import { ContentImage } from 'components/ContentImage/ContentImage';
import React, { FC } from 'react';
import type { ActionButton } from './ItemInfoAndActions';
import styles from './ItemActionButton.module.scss';
import cx from 'classnames';

interface IItemActionButtonProps {
  itemKey?: string;
  actionButton: ActionButton;
  handleActionClick: () => void;
  isDisabled?: boolean;
  handleFocus?: (e: any) => void;
}

export const ItemActionButton: FC<IItemActionButtonProps> = ({
  itemKey,
  actionButton,
  handleActionClick,
  isDisabled,
  handleFocus,
}) => (
  <button
    aria-label={actionButton.text}
    className={cx(styles.buttonFocus, { [styles.disabled]: isDisabled })}
    onClick={handleActionClick}
    disabled={isDisabled}
    data-heap-item={itemKey}
    onFocus={handleFocus}
  >
    {actionButton.imageEntry ? (
      <ContentImage entry={actionButton.imageEntry} isLazyLoad={false} />
    ) : (
      <p>{actionButton.text}</p>
    )}
  </button>
);
